import styled from 'styled-components';

export const ThemedMenu = styled.div`
  position: absolute;
  margin-left: 56px;
  top: 10px;
  ul {
    background: #122130;
    min-width: 150px;
    li:first-child {
      position: relative;
      margin-bottom: 8px;
      &:after {
        position: absolute;
        content: '';
        width: 100%;
        height: 1px;
        display: block;
        border-bottom: 1px solid #2b4054;
        top: 40px;
        left: 0;
      }
    }
    li.selected {
      color: #122130;
    }
    li {
      color: #ffffff;
      font-weight: 600;
      font-size: 14px;
    }
  }
`;

export const SidebarIcon = styled.div`
  opacity: 0.6;
  height: 36px;
  width: 36px;
  border-radius: 8px;
  display: grid;
  place-content: center;
  &.active {
    background-color: #2c3f52;
    opacity: 1;
    cursor: pointer;
  }
  :hover {
    background-color: #2c3f52;
    opacity: 1;
    cursor: pointer;
    @keyframes settings-rotate {
      0% {
        transform: rotate(0deg);
      }
      50% {
        transform: rotate(60deg);
      }
      100% {
        transform: rotate(0deg);
      }
    }

    @keyframes settings-scale {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(0.9);
      }
      100% {
        transform: scale(1);
      }
    }
    svg#settings {
      animation: settings-scale 0.5s linear;
      .path1 {
        transform-origin: center;
        animation: settings-rotate 1s ease-in-out;
      }
    }

    @keyframes analytics-line1 {
      0% {
        stroke-dashoffset: 0;
      }
      33.3% {
        stroke-dashoffset: -6;
      }
      50% {
        stroke-dashoffset: -3;
      }
      66.6% {
        stroke-dashoffset: -6;
      }
      100% {
        stroke-dashoffset: 0;
      }
    }
    @keyframes analytics-line2 {
      0% {
        stroke-dashoffset: -5;
      }
      33.3% {
        stroke-dashoffset: 0;
      }
      66.6% {
        stroke-dashoffset: -10;
      }
      100% {
        stroke-dashoffset: -5;
      }
    }
    @keyframes analytics-line3 {
      0% {
        stroke-dashoffset: -2;
      }
      33% {
        stroke-dashoffset: -10;
      }
      66% {
        stroke-dashoffset: 0;
      }
      100% {
        stroke-dashoffset: -2;
      }
    }

    svg#analytics :is(.path1, .path2, .path3) {
      animation-timing-function: linear;
      animation-duration: 1s;
      stroke-dasharray: 20;
    }
    svg#analytics {
      .path1 {
        animation-name: analytics-line1;
      }
      .path2 {
        animation-name: analytics-line2;
      }
      .path3 {
        animation-name: analytics-line3;
      }
    }

    @keyframes dashboard-rotate {
      0% {
        transform: rotate(0);
      }
      50% {
        transform: rotate(-300deg);
      }
      100% {
        transform: rotate(0deg);
      }
    }

    svg#dashboard .path1 {
      transform-origin: center;
      animation: dashboard-rotate 1s ease-in-out;
    }

    @keyframes survey-tick {
      0% {
        transform: translateX(0);
      }
      15% {
        stroke-dashoffset: 0;
      }
      25% {
        transform: translateX(4.5px);
      }
      50% {
        transform: translateX(4.5px);
        stroke-dashoffset: 16;
      }
      60% {
        stroke-dashoffset: 16;
      }
      75% {
        transform: translateX(4.5px);
        stroke-dashoffset: 0;
      }
      100% {
        transform: translateX(0px);
      }
    }
    @keyframes survey-line1 {
      0% {
        stroke-dashoffset: 0;
      }
      30%,
      70% {
        stroke-dashoffset: 5;
      }

      100% {
        stroke-dashoffset: 0;
      }
    }
    @keyframes survey-line2 {
      0% {
        stroke-dashoffset: 3;
      }
      30%,
      70% {
        stroke-dashoffset: 13;
      }
      100% {
        stroke-dashoffset: 3;
      }
    }

    svg#survey {
      .path1 {
        stroke-dasharray: 15 16;
        animation: survey-tick 1s linear alternate;
      }
      .line1 {
        animation: survey-line1 1s linear alternate;
        stroke-dasharray: 4 5;
      }
      .line2 {
        stroke-dasharray: 12 13;
        animation: survey-line2 1s linear alternate;
      }
    }
    @keyframes contact-grp {
      0% {
        transform: translateX(0px);
      }
      50% {
        transform: translateX(1.5px);
      }
      100% {
        transform: translateX(0px);
      }
    }
    @keyframes contact-grp1 {
      0% {
        transform: translateX(0px);
      }
      50% {
        transform: translateX(-1px);
      }
      100% {
        transform: translateX(0px);
      }
    }

    svg#contact {
      .grp1 {
        animation: contact-grp 0.8s linear;
      }
      .grp2 {
        animation: contact-grp1 0.8s linear;
      }
    }
    @keyframes response-path1 {
      0% {
        d: path(
          'M10 16H17C18.1046 16 19 15.1046 19 14V4C19 2.89543 18.1046 2 17 2H3C1.89543 2 1 2.89543 1 4V14C1 15.1046 1.89543 16 3 16H4.5'
        );
      }
      50% {
        d: path(
          'M14 16H17C18.1046 16 19 15.1046 19 14V4C19 2.89543 18.1046 2 17 2H3C1.89543 2 1 2.89543 1 4V14C1 15.1046 1.89543 16 3 16H9.5'
        );
      }
      100% {
        d: path(
          'M10 16H17C18.1046 16 19 15.1046 19 14V4C19 2.89543 18.1046 2 17 2H3C1.89543 2 1 2.89543 1 4V14C1 15.1046 1.89543 16 3 16H4.5'
        );
      }
    }
    @keyframes response-path2 {
      0% {
        d: path('M10 16H9L7 19L5 16H4.5');
      }
      50% {
        d: path('M15 16H14L12 19L10 16H9.5');
      }
      100% {
        d: path('M10 16H9L7 19L5 16H4.5');
      }
    }
    @keyframes response-translate {
      0% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(1px);
      }
      100% {
        transform: translateY(0px);
      }
    }
    svg#response {
      .path1 {
        animation: response-path1 0.8s linear;
      }
      .path2 {
        animation: response-path2 0.8s linear;
      }
      .grp1 {
        animation: response-translate 0.8s linear;
      }
    }
    @keyframes workflow-box1 {
      0% {
        transform: rotate(0deg);
      }
      20%,
      80% {
        transform: rotate(50deg);
      }
      100% {
        transform: rotate(0deg);
      }
    }
    @keyframes workflow-box2 {
      0%,
      20% {
        transform: rotate(0deg);
      }
      40%,
      80% {
        transform: rotate(-45deg);
      }
      100% {
        transform: rotate(0deg);
      }
    }
    @keyframes workflow-circle1 {
      0%,
      40% {
        transform: scale(1);
      }
      60%,
      80% {
        transform: scale(1.2);
      }
      100% {
        transform: scale(1);
      }
    }
    @keyframes workflow-circle2 {
      0%,
      60% {
        transform: scale(1);
      }
      80% {
        transform: scale(1.2);
      }
      100% {
        transform: scale(1);
      }
    }
    svg#workflow {
      .path1 {
        transform-origin: 4px 4px;
        animation: workflow-box1 1s linear;
      }
      .path2 {
        animation: workflow-circle1 1s linear;
        transform-origin: 16px 3px;
      }
      .path3 {
        animation: workflow-box2 1s linear;
        transform-origin: 16px 16px;
      }
      .path4 {
        animation: workflow-circle2 1s linear;
        transform-origin: 6px 16px;
      }
    }
  }
`;

export const StyledSidebar = styled.aside`
  width: 64px;
  height: 100vh;
  background-color: #122130;
  align-items: center;
  display: flex;
  flex-direction: column;
  z-index: 1200;
  .fsurvey {
    cursor: pointer;
  }
  .item {
    position: relative;
    height: 62px;
    width: 62px;
    padding: 14px;
    border-radius: 8px;
    div {
      border-radius: 8px;
    }
  }
  a {
    display: flex;
  }
  div:focus-visible,
  a:focus-visible {
    .icon-holder:not(.active) {
      border: 1px solid #fff;
    }
  }
`;
